/**
 * ClientMetadataStore
 * Extends the BaseStore for managing ClientMetadata.
 */

import BaseStore from '@legacy-src/Datastores/BaseStore';
import { ClientMetadataInterface } from '@sah/Classes/ClientMetadata';

class ClientMetadataStore extends BaseStore<ClientMetadataInterface> {}

export default new ClientMetadataStore();
